import { render, staticRenderFns } from "./GetDocumentHeadersDataComponent.vue?vue&type=template&id=bfeca356&scoped=true&"
import script from "./GetDocumentHeadersDataComponent.vue?vue&type=script&lang=js&"
export * from "./GetDocumentHeadersDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfeca356",
  null
  
)

export default component.exports